"use client";

import useServerTimeStore from "@/stores/useServerTimeStore";
import { fetchServerTime } from "@/lib/fetchServerTime";
import { useEffect } from "react";

const ServerTimer = () => {
  const { setServerTime } = useServerTimeStore();

  useEffect(() => {
    const sync = () => fetchServerTime(setServerTime);

    sync();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") sync();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("load", sync);
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("load", sync);
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, [setServerTime]);

  return null;
};

export default ServerTimer;
